import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-full flex items-center wide-only" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import COLORS from '@/design-system/colors.json';
import PieChartBase from '@/components/charts/pieChartBase.vue';
import { formatNumber } from '@/services/utils';
import DashboardOverviewDetails from './dashboard-overview-details.vue';
import DashboardOverviewTitle from './dashboard-overview-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-overview-total-builds',
  props: {
    totalWorkloads: null,
    totalWithBuildCache: null,
    totalWithoutBuildCache: null,
    hasBuildCacheInLicense: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  totalWorkloads?: number;
  totalWithBuildCache?: number;
  totalWithoutBuildCache?: number;
  hasBuildCacheInLicense: boolean;
}



const { t } = useI18n();

const totalBuildsDataset = computed(() => ({
  datasets: [
    {
      backgroundColor: [COLORS['System/app_secondary'], COLORS['Text/text_medium']],
      data: [props.totalWithBuildCache, props.totalWithoutBuildCache],
      borderWidth: 0,
    },
  ],
}));

const legend = computed(() =>
  props.hasBuildCacheInLicense
    ? [
        { title: t('dashboard.statusBar.withBuildCache'), value: formatNumber(props.totalWithBuildCache || 0), class: 'bg-System/app_secondary' },
        { title: t('dashboard.statusBar.withoutBuildCache'), value: formatNumber(props.totalWithoutBuildCache || 0), class: 'bg-Text/text_medium' },
      ]
    : [],
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardOverviewDetails, { legend: _unref(legend) }, {
    title: _withCtx(() => [
      _createVNode(DashboardOverviewTitle, {
        class: "pb-3",
        "data-testid": "dashboard-overview-total-builds",
        title: _unref(t)('dashboard.statusBar.totalBuilds'),
        value: _unref(formatNumber)(__props.totalWorkloads || 0)
      }, null, 8, ["title", "value"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.hasBuildCacheInLicense)
          ? (_openBlock(), _createBlock(PieChartBase, {
              key: 0,
              style: {"height":"80px","width":"80px","border-width":"0"},
              "chart-data": _unref(totalBuildsDataset)
            }, null, 8, ["chart-data"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["legend"]))
}
}

})